import { cn } from "@/client/lib/utils";

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      className={cn(
        "animate-pulse rounded-md bg-oklch(0.97 0 0) dark:bg-secondary/40",
        className,
      )}
      {...props}
    />
  );
}

export { Skeleton };
